<template>
    <div class="page">
        <box fill>
            <el-form label-position="right" label-width="100px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="库位" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.laCode" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="杂入杂出编号" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.sorCode" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.matCode" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5" v-if="pagination.fcCode">
                    <el-form-item label="批号" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.batchNo" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getAuxiMaterialData()">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="resetData()">
                            重置
                        </el-button>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5" v-if="!pagination.fcCode">
                    <el-form-item label="批号" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.batchNo" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="类型" class="EL-Form-Item">
                        <el-select v-model="pagination.sorType" placeholder="请选择">
                            <el-option label="杂入" value="10"></el-option>
                            <el-option label="杂出" value="20"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <!-- <el-col :lg="5" :xl="5">
          <el-form-item label="操作人" class="EL-Form-Item">
            <el-input placeholder="请输入" v-model="pagination.person">
            </el-input>
          </el-form-item>
        </el-col> -->
               
            </el-form>
            <el-divider></el-divider>
            <plabel text="杂入杂出表报">
                <el-button v-authority="'BACK_MENU7_M11_B1'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
            </plabel>
            <!-- 展示 -->
            <h-table :headerCellStyle="headerCellStyle" style="flex: 1" @pageChange="getAuxiMaterialData" :data="mainData" pagination :nowPage.sync="pagination.pageNum" :pageSize.sync="pagination.pageSize" :total.sync="pagination.total">
                <el-table-column prop="laCode" label="库位编号" />
                <el-table-column prop="sorCode" label="杂入杂出编号" />
                <el-table-column prop="matCode" label="物料编号" />
                <el-table-column prop="matName" label="物料描述" />
                <el-table-column prop="matQuan" label="物料数量" />
                <el-table-column prop="batchNo" label="批号" />
                <el-table-column prop="sorType" label="类型">
                    <template slot-scope="scope">
                        <div v-if="scope.row.sorType == 10">杂入</div>
                        <div v-if="scope.row.sorType == 20">杂出</div>
                    </template>
                </el-table-column>
                <el-table-column prop="personNumber" label="工号" />
                <el-table-column prop="person" label="操作人" />
                <el-table-column prop="createTime" label="创建时间" />
            </h-table>
        </box>
    </div>
</template>

<script>
    export default {
        name: "inventoryRecordIn",
        data() {
            return {
                headerCellStyle: () => {
                    return "background-color: #1f5cec";
                },
                form: {},
                //主数据
                mainData: [],
                pagination: {
                    pageNum: 1,
                    pageSize: 50,
                    total: 0,
                    sorCode: "",
                    matCode: "",
                    batchNo: "",
                    // person: localStorage.getItem("user") || "",
                    fcCode: localStorage.getItem("fcCode") || "",
                    sorType: "",
                    laCode: ""
                },
                taskTab: "0",

                downloadLoading: false, //下载中

                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注
                // 输入框延时加载
                isSetTimeout: null,
            };
        },
        watch: {
            pagination: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.getAuxiMaterialData(newVal);
                    },1000)
                },
                deep: true,
            },
        },
        methods: {
            // 节流搜索
            saveSearch() {
                if (window.lazy) window.clearTimeout(window.lazy)
                window.lazy = window.setTimeout(() => {
                    this.getAuxiMaterialData()
                }, 1000)
            },
            //获取数据
            getAuxiMaterialData() {
                this.$http
                    .request({
                        url: "/api/otherRecord/getOtherRecordData",
                        method: "GET",
                        params: this.pagination,
                    })
                    .then((resp) => {
                        this.loading--;
                        if (resp.status == 100) {
                            this.mainData = resp.data.list || [];
                            this.pagination.total = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        this.loading--;
                    });
            },
            //重置
            resetData() {
                this.pagination = {
                    pageNum: 1,
                    pageSize: 50,
                    total: 0,
                    sorCode: "",
                    matCode: "",
                    batchNo: "",
                    // person: localStorage.getItem("user") || "",
                    fcCode: localStorage.getItem("fcCode") || "",
                    sorType: "",
                    laCode: ""
                };
                this.getAuxiMaterialData();
            },

            //表格导出
            downLoadFile() {
                this.downloadLoading = true;
                var paramsObj = {
                    sorCode: this.pagination.sorCode,
                    matCode: this.pagination.matCode,
                    batchNo: this.pagination.batchNo,
                    // person: localStorage.getItem("user") || "",
                    fcCode: this.pagination.fcCode,
                    sorType: this.pagination.sorType,
                    laCode: this.pagination.laCode,
                    pageNum: 1,
                    pageSize: 999999,
                }

                this.$http.request({
                    url: '/api/otherRecord/getOtherRecordData',
                    method: 'GET',
                    showLoading: true,
                    params: paramsObj
                }).then((resp) => {
                    resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                        message: '查询失败'
                    });
                })
            },
            downLoad(list) {
                import('@/libs/Export2Excel').then(excel => {
                    list.forEach(function(c) {
                        if (c.sorType == "10") {
                            c['sorType'] = '杂入'
                        } else if (c.sorType == "20") {
                            c['sorType'] = '杂出'
                        }
                    })
                    const tHeader = ['库位编号', '杂入杂出编号', '物料编号', '物料描述', '物料数量', '批号', '类型', '工号', '操作人', '创建时间']
                    const filterVal = ['laCode', 'sorCode', 'matCode', 'matName', 'matQuan', 'batchNo', 'sorType', 'personNumber', 'person', 'createTime']
                    const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '杂入杂出报表数据'
                    })
                    this.logContent = "导出"
                    this.logRemarks = "stock_check_task：导出杂入杂出报表数据"
                    this.systemLog();
                    this.downloadLoading = false
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },

            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "杂入杂出报表",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },

        },
        activated(){
            /* 获取首页的数据 */
            this.getAuxiMaterialData();
        },
    };
</script>

<style scoped>
</style>